// @ts-check
import React from 'react';
import { wrapFormComponentWithError } from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import { SignaturePad } from '../../../components/SignaturePad';

const RawSignaturePad = ({ value, onChange }) => (
  <SignaturePad value={value} onChange={onChange} editable />
);

// const RawSignatureField = wrapFormComponentWithLabelAndError(RawSignaturePad);
// RawSignatureField.displayName = 'RawSignatureField';
const RawSignatureField = ({ name, label, meta, wrapperProps, children, ...inputProps }) => {
  const showError = meta && meta.touched && meta.error;
  const errorClassName = showError ? 'rounded border border-red-500' : '';
  return (
    <div id={`${name}--sig-wrapper`} className={`max-w-3xl mx-auto ${errorClassName}`}>
      <p style={{ whiteSpace: 'pre-wrap' }} className="py-8">
        {label}
      </p>
      <div>
        <RawSignaturePad {...inputProps} />
      </div>
      {showError ? <p className="help-inline text-red-500">{meta.error}</p> : null}
    </div>
  );
};

const SignatureField = connectFormComponentToReduxForm(RawSignatureField);
SignatureField.displayName = 'SignatureField';
export default SignatureField;

const SignatureInput = connectFormComponentToReduxForm(wrapFormComponentWithError(RawSignaturePad));

export { SignatureInput };
